/**
 * MUI Output Component
 * 
 * This component is the Material UI equivalent of the original Output component.
 * It displays a value from the Redux store with an optional label.
 */

import React from 'react';
import { Box, Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { InputLabel } from '../atoms';
import { GettersIndex } from 'reduxModules/ducks';
import { OutputProps } from 'types/components/molecules';

/**
 * MUI Output component
 * 
 * @param props - Component props
 * @returns The MUI Output component
 */
const MuiOutput: React.FC<OutputProps> = (props) => {
  // Get the value from the Redux store
  // Cast GettersIndex to any to avoid TypeScript errors with indexing
  const getters = GettersIndex as any;
  
  const value = useSelector((state: any) => 
    getters[props.getter] ? getters[props.getter](state) : null
  );

  return (
    <Box className={`d-flex flex-wrap gap-1 ${props.className || ''}`}>
      {props.label && <InputLabel>{props.label}</InputLabel>}
      <Typography variant="body1">{value}</Typography>
    </Box>
  );
};

export type { OutputProps };
export default MuiOutput;
